/**
 * Output template permission (SC-3339).
 *
 * One gate for the whole feature: holding it means the output-template builder is available — the
 * Products sub-nav entry, the library, authoring, and eventually generating. Not holding it means
 * the feature is hidden in the UI and refused by the API.
 *
 * Deliberately not split into view/manage/generate. The legacy shipping-label routers enforce no
 * server-side RBAC at all, so a single access gate is already stricter than production and far
 * easier to roll out for the beta. A finer split can be introduced later without renaming this one,
 * if authoring ever needs to be narrower than printing.
 *
 * Module-owned, like `PricingEnginePermission`, and re-exported through
 * `~/shared/types/RBACPermission` so the union and the seed see it.
 */
export enum OutputTemplatePermission {
  access = "outputTemplates.access",
}
